import { createDecorator } from "../../instantiation/common/registry.js";
import { IUndoRedoElement } from "./action.js";
import { Event } from "../../../base/common/events.js";

export interface IUndoRedoService {
    readonly onDidChange: Event<void>;

    push(action: IUndoRedoElement): void,
    get canUndo(): boolean,
    get canRedo(): boolean,
    undo(): Promise<void> | void,
    redo(): Promise<void> | void,
    clear(): void,
}

export const IUndoRedoService = createDecorator<IUndoRedoService>('undoRedoService');





